var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Intro(el) {
	var urlFull = window.location.href;
	var checkURLRedirect = urlFull && urlFull.includes('#id=');
	if ($(el) && $(el).hasClass('intro--reservation') && checkURLRedirect) {
		var $secondaryBrandElm = $(el).find('.intro__header');
		if ($secondaryBrandElm && $secondaryBrandElm.hasClass('intro__header')) {
			$secondaryBrandElm.removeClass('intro__header');
		}
	}
}

module.exports = Intro;
